export default __webpack_public_path__ + "static/media/PS.c3e18206.svg";